"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const ToggleSwitcher_1 = require("../../ToggleSwitcher");
require("./tile.scss");
const Tile = (props) => {
    const { className, title, description, isActive, id, onChange, disabled } = props;
    const classNames = (0, classnames_1.default)('tile', className !== null && className !== void 0 ? className : '');
    const onChangeHandler = (0, react_1.useCallback)((e) => {
        onChange(id, e.target.checked);
    }, [onChange, id]);
    return (react_1.default.createElement("li", { className: classNames },
        react_1.default.createElement("div", { className: 'tile__title' }, title),
        description && (react_1.default.createElement("div", { className: 'tile__description' }, description)),
        react_1.default.createElement("div", { className: 'tile__switch' },
            react_1.default.createElement(ToggleSwitcher_1.ToggleSwitcher, { checked: isActive, onChange: onChangeHandler, disabled: disabled }))));
};
exports.Tile = Tile;
//# sourceMappingURL=Tile.js.map